import { render } from "./App.vue?vue&type=template&id=28052c3d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=28052c3d&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/goatsd.com_VUE.js_main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__